<template>
    <v-btn class="unlock-btn" @click="dialog = true" rounded>Odemkni</v-btn>
    <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
            <v-card-title class="text-h5">Znovuodemčení formuláře</v-card-title>
            <v-card-text>Po znovuodemčení se uživateli zpřístupní formulář a bude ho moci znovu vypracovat a odeslat.
                {{ userUid }} na nástěnce '{{ noticeboardName }}'
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="unlockAction" rounded>Odemknout</v-btn>
                <v-btn color="red darken-1" text @click="dialog = false" rounded>Zrušit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';  // Importujeme axios pro HTTP requesty
import { baseURL } from '@/Baseurl.js';  // Importujeme baseURL z @baseUrl.js

export default {
    props: {
        noticeboardName: String,
        userUid: String,
        noticeboardId: String
    },
    data() {
        return {
            dialog: false,  // Tato proměnná řídí zobrazení dialogu
        }
    },
    methods: {
        unlockAction() {
            const url = `${baseURL}/api/toggle-noticeboard-checkout`;
            const data = {
                user_id: this.userUid,
                noticeboard_id: this.noticeboardId,
                status: null
            };

            axios.put(url, data)
                .then(response => {
                    this.dialog = false;
                    // Emitujeme událost s odpovědí serveru nebo jinými relevantními daty
                    this.$emit('unlocked', { noticeboardId: this.noticeboardId, updatedData: response.data });
                })
                .catch(error => {
                    alert(`Chyba při odemykání: ${error.response.data.error}`);
                });
        }
    }
}
</script>

<style scoped>
.unlock-btn {
    margin-left: 10px;
}
</style>
